/**
@license
Copyright (c) 2019 Behavio Labs s.r.o. All rights reserved.
*/

import { LitElement, html, css, customElement } from 'lit-element';

@customElement('snack-bar')
class SnackBar extends LitElement {
  static get properties() {
    return {
      active: { type: Boolean },
    };
  }

  static get styles() {
    return [
      css`
        :host {
          position: fixed;
          top: 100%;
          right: 0;
          left: 0;
          display: block;
          padding: 12px;
          color: white;
          text-align: center;
          visibility: hidden;
          background-color: var(--app-secondary-color);
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
          transition-duration: 0.2s;
          transition-property: visibility, transform;
          transform: translate3d(0, 0, 0);
          will-change: transform;
        }

        :host([active]) {
          visibility: visible;
          transform: translate3d(0, -100%, 0);
        }

        @media (min-width: 460px) {
          :host {
            width: 320px;
            margin: auto;
          }
        }
      `,
    ];
  }

  render() {
    return html`
      <slot></slot>
    `;
  }
}
